import { ForecastHorizontalDetailBase } from './base/forecast-horizontal-detail-base';

export class ForecastHorizontalDetail extends ForecastHorizontalDetailBase { }